import moment from "moment";

import type {
  BalanceDetailUiT,
  HistoryDetailUiT,
} from "../domain/ui/requestDetail.model";
import type { RequestStatusT } from "../domain/types/requestStatus.types";

import { REQUEST_STATUS } from "../constants/status";
import { VACATION_REQUESTS_STRINGS } from "../constants/strings";

const formatDate = (date: Date) =>
  date ? moment.utc(date).format("DD/MM/YYYY") : "—";

type RequestDataPropsT = {
  processedBy: string;
  status: RequestStatusT;
  createdDate: Date;
  reason: string;
  balance: BalanceDetailUiT;
  history: HistoryDetailUiT[];
};

const RequestData = ({
  processedBy,
  status,
  createdDate,
  reason,
  balance,
  history,
}: RequestDataPropsT) => {
  const lastElementHistory = history?.length > 0 ? history.at(-1) : null;

  let statusComments = null;
  if (
    (status === REQUEST_STATUS.REJECTED ||
      status === REQUEST_STATUS.CANCELLED) &&
    !!lastElementHistory
  )
    statusComments = lastElementHistory.reason;

  return (
    <section
      aria-label="Detalles de la solicitud"
      className="flex flex-col gap-2"
    >
      <dl className="flex flex-col gap-2">
        {!!processedBy && (
          <div className="flex">
            <dt>{VACATION_REQUESTS_STRINGS.PROCESSED_BY_LABEL}</dt>
            <dd
              title={processedBy}
              className="flex-1 font-medium text-right truncate"
            >
              {processedBy}
            </dd>
          </div>
        )}

        {!!balance && (
          <>
            <div className="flex">
              <dt>
                {VACATION_REQUESTS_STRINGS.DETAIL_DAYS_NOT_CONSIDERED_LABEL}
              </dt>
              <dd className="flex-1 font-medium text-right">
                {balance.excludedDays} días
              </dd>
            </div>
            <div className="flex">
              <dt>
                {VACATION_REQUESTS_STRINGS.DETAIL_AVAILABLE_BALANCE_LABEL}
              </dt>
              <dd className="flex-1 font-medium text-right">
                {balance.available} días
              </dd>
            </div>
            {status === REQUEST_STATUS.PENDING && (
              <div className="flex">
                <dt>
                  {VACATION_REQUESTS_STRINGS.DETAIL_REMAINING_BALANCE_LABEL}
                </dt>
                <dd className="flex-1 font-medium text-right">
                  {balance.remaining} días
                </dd>
              </div>
            )}
          </>
        )}

        {!!statusComments && (
          <div
            role="alert"
            aria-live="polite"
            className="flex flex-col gap-0.5"
          >
            <dt>{VACATION_REQUESTS_STRINGS.DETAIL_REASON_LABEL}</dt>
            <dd className="font-medium">{statusComments}</dd>
          </div>
        )}

        {!!createdDate && (
          <div className="flex">
            <dt>{VACATION_REQUESTS_STRINGS.DETAIL_CREATED_DATE_LABEL}</dt>
            <dd className="flex-1 font-medium text-right">
              {formatDate(createdDate)}
            </dd>
          </div>
        )}

        {!!reason && (
          <div className="flex flex-col gap-0.5">
            <dt>{VACATION_REQUESTS_STRINGS.DETAIL_COMMENTS_LABEL}</dt>
            <dd className="font-medium">{reason}</dd>
          </div>
        )}
      </dl>
    </section>
  );
};

export default RequestData;
